import React, { useState, useEffect, useCallback, useRef } from "react";
import "./cygnusgpt.css"
import { Button, Row, Col, Nav, Tab, Card, Image } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import { logout, capitalizeFirstLetter } from "../../utils";
import Form from "react-bootstrap/Form";
import { v4 } from "uuid";
import { Comment } from "react-loader-spinner";
import { makeCygnusApiCall } from "../../api/api";

const CygnusGptDashboard = (gpt_dashboard_props) => {
    const username = localStorage.getItem("user")
    const [chat, setChat] = useState([])
    const [sampleQuestions, setSampleQuestions] = useState([])
    const [similarQuestions, setSimilarQuestions] = useState([])
    const [favoriteQuestions, setFavoriteQuestions] = useState([])
    const [value, setValue] = useState("")
    const onInput = ({ target: { value } }) => {
        setValue(value)
    }
    const [isLoading, setIsLoading] = useState(false)
    const addChat = async (e) => {
        e.preventDefault()
        const newQuestion = {
            "ChatBy": "user",
            "Chat": value,
            "UpdatedDate": new Date().toLocaleString() + ""
        }
        const loadingResponse = {
            "ChatBy": "chatgpt",
            "Chat": "loading",
            "UpdatedDate": new Date().toLocaleString() + ""
        }
        setIsLoading(true)
        setChat([...chat, newQuestion, loadingResponse]);
        const data = await makeCygnusApiCall({
            type: "POST",
            payload: { "text": value },
            url: "/chatgpt/",
            show_message: false,
            customized_success_message: "Successful.",
            customized_failure_message: "Unable to respond to the query, please try again. If the problem persists, please contact support and attach a screenshot.",
            customized_error_message: "Error occured while responding to this query, please contact support and attach a screenshot.",
            isblob: false
        })
        if (data.success) {
            setIsLoading(false)
            setChat([...chat, newQuestion, data.data[0]])
        }
    };

    const addTileChat = async (question_from_tile) => {
        console.log("QUESTION FROM TILE: ", question_from_tile)
        const newQuestion = {
            "ChatBy": "user",
            "Chat": question_from_tile,
            "UpdatedDate": new Date().toLocaleString() + ""
        }

        const loadingResponse = {
            "ChatBy": "chatgpt",
            "Chat": "loading",
            "UpdatedDate": new Date().toLocaleString() + ""
        }
        setIsLoading(true)
        setChat([...chat, newQuestion, loadingResponse]);
        const data = await makeCygnusApiCall({
            type: "POST",
            payload: { "text": question_from_tile },
            url: "/chatgpt/",
            show_message: false,
            customized_success_message: "Successful.",
            customized_failure_message: "Unable to respond to the query, please try again. If the problem persists, please contact support and attach a screenshot.",
            customized_error_message: "Error occured while responding to this query, please contact support and attach a screenshot.",
            isblob: false
        })
        if (data.success) {
            setIsLoading(false)
            setChat([...chat, newQuestion, data.data[0]])
            setSimilarQuestions(data.data[0].SimilarQuestions)
        }
    };

    const messagesEndRef = useRef(null);
    const scrollToBottom = () => {
        messagesEndRef.current.scrollIntoView({ behavior: "smooth" })
    };

    useEffect(scrollToBottom, [chat]);

    const ChatHolder = ({ messages }) => {
        console.log("CHAT HOLDER MESSAGES: ", messages)
        let mess;
        if (messages.length == 0) {
            return (
                <div className="chat-log">
                    <p>Hey! I am Cygnus Intelligence. Ask me anything about your firm statistics and I'll find an answer for you.</p>
                </div>
            )
        } else {
            mess = messages
        }

        return (
            <div className="chat-log">
                {
                    mess.map((message) => (
                        message.ChatBy === "user"
                            ?
                            <UserQuestionRenderer
                                key={v4()}
                                question={message.Chat}
                                isFavorite={message.IsFavourite}
                            />
                            :
                            <CygnuGptResponseRenderer
                                key={v4()}
                                response={message.Chat}
                            />
                    ))
                }
            </div>
        );
    };

    useEffect(() => {
        const getChatGpt = async () => {
            const data = await makeCygnusApiCall({
                type: "GET",
                payload: {},
                url: "/chatgpt/",
                show_message: false,
                customized_success_message: "Successful.",
                customized_failure_message: "Unable to fetch chat, please try again. If the problem persists, please contact support and attach a screenshot.",
                customized_error_message: "Error occured while fetching chat, please contact support and attach a screenshot.",
                isblob: false
            })
            if (data.success) {
                for (let favquestion in data["FavouriteQuestions"]) {
                    for (let chat in data["data"]) {
                        if (data["data"][chat].Chat == data["FavouriteQuestions"][favquestion].Question) {
                            data["data"][chat].IsFavourite = true
                        }
                    }
                }
                setChat(data["data"]);
                setSampleQuestions(data["RecommendedQuestions"])
                setFavoriteQuestions(data["FavouriteQuestions"])
            }
        }
        getChatGpt()
    }, []);

    const handleFavoriteClick = async (question) => {
        console.log("SPLICE KIYA!: ", favoriteQuestions.splice(favoriteQuestions.findIndex(a => a.Question === question), 1))
        setFavoriteQuestions(favoriteQuestions.splice(favoriteQuestions.findIndex(a => a.Question === question), 1))
        const new_chat = chat.map(obj => {
            if (obj.Chat == question) {
                obj.IsFavourite = false;
            }
            return obj;
        })
        console.log("NEW CHAT: ", new_chat)
        setChat(new_chat)
        const _ = await makeCygnusApiCall({
            type: "POST",
            payload: { "text": question, "RemoveFavourite": true },
            url: "/chatgpt/",
            show_message: false,
            customized_success_message: "Successful.",
            customized_failure_message: "Unable to remove from favourites, please try again. If the problem persists, please contact support and attach a screenshot.",
            customized_error_message: "Error occured while removing from favourites, please contact support and attach a screenshot.",
            isblob: false
        })
    }

    const UserQuestionRenderer = (props) => {
        const [favorite, setFavorite] = useState(props.isFavorite)
        const handleFavoriteIntClick = async (fav) => {
            console.log("FAVOURITE VALUEEEEEE: ", fav)
            setFavorite(fav)
            if (fav == true) {
                setFavoriteQuestions([...favoriteQuestions, {
                    "Question": props.question
                }])
            } else {
                console.log("SPLICE KIYA!: ", favoriteQuestions.splice(favoriteQuestions.findIndex(a => a.Question === props.question), 1))
                setFavoriteQuestions(favoriteQuestions.splice(favoriteQuestions.findIndex(a => a.Question === props.question), 1))
            }

            const new_chat = chat.map(obj => {
                if (obj.Chat == props.question) {
                    obj.IsFavourite = fav;
                }
                return obj;
            })
            setChat(new_chat)
            const _ = await makeCygnusApiCall({
                type: "POST",
                payload: { "text": props.question, "IsFavourite": fav },
                url: "/chatgpt/",
                show_message: false,
                customized_success_message: "Successful.",
                customized_failure_message: "Unable to add to favourites, please try again. If the problem persists, please contact support and attach a screenshot.",
                customized_error_message: "Error occured while adding to favourites, please contact support and attach a screenshot.",
                isblob: false
            })
        }

        return (
            <Row className="chat-log__item no-gutter">
                <Col md={1} className="flex-column-center-center">
                    <Icon.PersonFill
                        style={{ width: 40, borderRadius: 10, fontSize: 40 }}
                    />
                    <p className="chat-log__author">{capitalizeFirstLetter(username)}</p>
                </Col>
                <Col md={11} className="flex-column-start-center">
                    <div className="chat-log__message">{props.question}</div>
                    <div className="toggle favorite-item heart pointer" style={{ marginTop: "-15px" }} onClick={() => handleFavoriteIntClick(!favorite)}>
                        {favorite ? <Icon.HeartFill /> : <Icon.Heart />}
                    </div>
                </Col>
            </Row>
        )
    }

    const clearChat = async () => {
        const data = await makeCygnusApiCall({
            type: "GET",
            payload: { "text": value },
            url: "/chatgpt/",
            show_message: false,
            customized_success_message: "Successful.",
            customized_failure_message: "Unable to clear chat, please try again. If the problem persists, please contact support and attach a screenshot.",
            customized_error_message: "Error occured while clearing chat, please contact support and attach a screenshot.",
            isblob: false
        })
        if (data) {
            setChat(data["data"]);
        }
    }

    const QuestionTileRenderer = (props) => {
        return (
            props.isFavorite
                ?
                <div className="question-tile-fav">
                    <Icon.SendFill className="question-tile-icon" onClick={() => addTileChat(props.text)} /> {props.text}<Icon.HeartFill className="pointer" style={{ color: "#bd0155", float: "right" }} onClick={() => handleFavoriteClick(props.text)} />
                </div>
                :
                <div className="question-tile" onClick={() => addTileChat(props.text)}>
                    <Icon.SendFill className="question-tile-icon" /> {props.text}
                </div>
        )
    }


    const CygnuGptResponseRenderer = (props) => {
        return (
            <Row className="chat-log__item chat-log__item--own no-gutter">
                <Col md={1} className="flex-column-center-center">
                    <Image
                        src={`${process.env.REACT_APP_BASE_URI}/static/workflow/applogos/undefined.png`}
                        style={{ width: 40, borderRadius: 10 }}
                    />
                    <p className="chat-log__author">Cygnus</p>
                </Col>
                <Col md={11} className="flex-row-center-start">
                    {
                        props.response === "loading"
                            ?
                            <Comment
                                visible={true}
                                height="80"
                                width="80"
                                ariaLabel="comment-loading"
                                wrapperStyle={{}}
                                wrapperClass="comment-wrapper"
                                color="var(theme1_primary)"
                                backgroundColor="#fff"
                            />
                            :
                            <div className="chat-log__message">{props.response}</div>
                    }
                </Col>
            </Row>
        )
    }

    return (
        <Row className="chat-gpt">
            <Col md={2} className="chat-side-wrapper">
                <h5>Favorite questions</h5>
                <div className="favorite-question-container">
                    {
                        favoriteQuestions.length == 0
                            ?
                            <p style={{ marginTop: 10 }}>Your favorite questions will be displayed here. Click on ❤ to add questions to your favorite list.</p>
                            :
                            favoriteQuestions.map((question, index) => (
                                <QuestionTileRenderer key={index} text={question.Question} isFavorite={true} />
                            ))
                    }
                </div>

                <div className="similar-questions-container">
                    <h5>Similar questions</h5>
                    <div className="favorite-question-container">
                        {similarQuestions.length === 0 ? (
                            <p style={{ marginTop: 10 }}>
                                Ask a question and we will recommend similar other personalized questions for you.
                            </p>
                        ) : (
                            similarQuestions.map((question, index) => (
                                <QuestionTileRenderer key={index} text={question} />
                            ))
                        )}
                    </div>
                </div>
            </Col>
            <Col md={10} className="chat-wrapper">
                <div className="yo-header">
                    <h4>Cygnus conversational insights bot</h4>
                    <Button className="clear-chat" onClick={() => clearChat()}>Clear chat</Button>
                </div>
                <ChatHolder
                    messages={chat}
                />
                <div className="chat-form">
                    <Form className="form-horizontal" onSubmit={addChat}>
                        <Row className="no-gutter">
                            <div className="chat-gpt-input-container">
                                <Form.Control
                                    type="text"
                                    onChange={onInput}
                                    value={value}
                                    className="form-control chat-gpt-input custom-input"
                                    id=""
                                    placeholder="Send a message."
                                />
                                <div className="send-icon-gpt">
                                    <Icon.SendFill type="submit" onClick={(e) => addChat(e)} />
                                </div>
                            </div>
                            <div className="question-tiles-wrapper">
                                {
                                    sampleQuestions.map((question, index) => (
                                        <QuestionTileRenderer key={index} text={question} />
                                    ))
                                }
                            </div>
                        </Row>
                    </Form>
                </div>

                <div ref={messagesEndRef} />
            </Col>
        </Row>
    )
}

export default CygnusGptDashboard;
